import { render } from "./LootBoxOpenPrize.vue?vue&type=template&id=0530f65a"
import script from "./LootBoxOpenPrize.vue?vue&type=script&lang=js"
export * from "./LootBoxOpenPrize.vue?vue&type=script&lang=js"

import "./LootBoxOpenPrize.vue?vue&type=style&index=0&id=0530f65a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__